import { render } from "./ShowForexAccount.vue?vue&type=template&id=a6ae1686"
import script from "./ShowForexAccount.vue?vue&type=script&lang=js"
export * from "./ShowForexAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__